import React from "react";
import {Overlay} from "../../shared/Overlay";
import {Alert, AlertTitle} from "@mui/material";
import Stack from "@mui/material/Stack";
import {Button} from "@material-ui/core";
import {useMutation, useQueryClient} from "react-query";
import Notifications from "../../shared/Notifications";
import {deleteNewHoses} from "../../../utils/requests/NewHoses";

const DeleteNewHoseOverlay = ( {
                                   closeOverlay,
                                   newHose
                               } ) => {
    const queryClient = useQueryClient();

    const deleteRepairMutation = useMutation( () => deleteNewHoses( newHose.id ), {
        onSuccess: () => {
            Notifications.showSuccess( "Die hinterlegten Schläuche wurden erfolgreich gelöscht!" );
            queryClient.refetchQueries( ["getAllNewHosesBetweenDates"] ).then( closeOverlay() );
        },
        onError: ( error ) => {
            Notifications.showError( "Die hinterlegten Schläuche konnte nicht gelöscht werden!" );
            console.log( error );
        },
    } );

    const footerContent = (<Stack spacing={2} direction="row">
                <Button color="primary" variant="contained" type="submit" onClick={() => deleteRepairMutation.mutate()}>
                    Bestätigen
                </Button>
                <Button color="primary" variant="outlined" onClick={() => closeOverlay()}>
                    Abbrechen
                </Button>
            </Stack>);

    return (<Overlay
                    onClose={() => closeOverlay()}
                    headerContent={<h2>Hinzugefügte Schläuche löschen?</h2>}
                    footerContent={footerContent}
                    size={"s"}
            >
                <Alert severity="info">
                    <AlertTitle>Wichtiger Hinweis</AlertTitle>
                    Durch das löschen der hinzugefügten Schläuche werden diese unwiderruflich gelöscht! Ein nachträgliches
                    wiederherstellen der Daten ist nicht möglich!
                    <br/>
                    <br/>
                    Es ist möglich gelöschte Eingaben zu einem späteren Zeitpunkt zu exportieren.
                </Alert>
            </Overlay>);
};

export default DeleteNewHoseOverlay;
